/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Content_Sound_SubtitleInputs */

const en_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 popular trees from current collections.`)
};

const ar_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 شجرة مشهورة من المجموعات الحالية.`)
};

const de_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 beliebte Bäume aus aktuellen Kollektionen.`)
};

const es_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 árboles populares de colecciones actuales.`)
};

const fr_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 arbres populaires issus des collections actuelles.`)
};

const it_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 alberi popolari dalle collezioni attuali.`)
};

const ja_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在のコレクションから厳選された15種類の樹種`)
};

const ko_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 컬렉션의 인기 나무 15종.`)
};

const pt_br_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 árvores populares das coleções atuais.`)
};

const ru_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 популярных деревьев из текущих коллекций.`)
};

const th_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้ยอดนิยม 15 ต้นจากคอลเล็กชันปัจจุบัน`)
};

const tr_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncel koleksiyonlardan 15 popüler ağaç.`)
};

const zh_cn_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`现有内容中挑选热门的 15 棵树种`)
};

const zh_tw_subscription_exclusive_content_sound_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_Sound_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現有內容中挑選熱門的 15 棵樹種`)
};

/**
* | output |
* | --- |
* | "15 popular trees from current collections." |
*
* @param {Subscription_Exclusive_Content_Sound_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_content_sound_subtitle = /** @type {((inputs?: Subscription_Exclusive_Content_Sound_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Content_Sound_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_content_sound_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_content_sound_subtitle(inputs)
	return zh_tw_subscription_exclusive_content_sound_subtitle(inputs)
});